module.exports = __webpack_public_path__ + "img/bg-b.a55795c7.png";